module.exports = __webpack_public_path__ + "img/Kitchen.efb970b6.png";